import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import popularModels from "../data/popularcar.json";
import "../styles/popular-vehicles.css";

function PopularVehicles() {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState("All");

  const categories = [
    "All",
    "SUV",
    "Sedan",
    "Hybrid",
    "Mini Van",
    "Mini SUV",
    "Mini Car",
    "Van",
  ];

  const filteredModels =
    selectedCategory === "All"
      ? popularModels
      : popularModels.filter((model) => model.category === selectedCategory);

  return (
    <div className="popular-vehicles-page">
      <div className="pv-header">
        <button className="pv-back-btn" onClick={() => navigate(-1)}>
          ← Back
        </button>

        <h1>Popular Vehicle Models</h1>
        <p>Most popular imported Japanese vehicles in Sri Lanka</p>
      </div>

      <div className="pv-filter-section">
        <div className="pv-filters">
          {categories.map((category) => (
            <button
              key={category}
              className={`pv-filter-btn ${
                selectedCategory === category ? "active" : ""
              }`}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>
      </div>

      <div className="pv-gallery-container">
        <div className="pv-gallery-grid">
          {filteredModels.map((model) => (
            <div key={model.id} className="pv-model-card">
              <div className="pv-card-emoji">
                {typeof model.image === "string" && model.image.startsWith("/") ? (
                  <img
                    src={model.image}
                    alt={model.name}
                    className="pv-card-image"
                  />
                ) : (
                  model.image
                )}
              </div>

              <div className="pv-card-content">
                <h3>{model.name}</h3>
                <p className="pv-card-category">{model.category}</p>
                <p className="pv-card-year">Model Years: {model.year}</p>
                <p className="pv-card-description">{model.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="pv-results-info">
        <p>
          Showing <strong>{filteredModels.length}</strong> of {" "}
          <strong>{popularModels.length}</strong> vehicle models
        </p>
      </div>
    </div>
  );
}

export default PopularVehicles;
